export const gNormalId = (() => {
  let normalId = 1;
  return () => {
    return normalId++;
  };
})();
